/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { DocumentOcrSnapshotResultViewModel } from "../types/DocumentOcrSnapshotResultViewModel.ts";
import { documentOcrAnalysisViewModelSchema } from "./documentOcrAnalysisViewModelSchema.ts";
import { documentOcrPersonalDataViewModelSchema } from "./documentOcrPersonalDataViewModelSchema.ts";

export const documentOcrSnapshotResultViewModelSchema = z.object({
  courseRegistrationId: z.optional(
    z.number().int().describe("ID da matrícula analisada."),
  ),
  personId: z.optional(
    z
      .number()
      .int()
      .describe(
        "ID da pessoa (aluno); 0 quando a matrícula não foi encontrada.",
      ),
  ),
  error: z
    .string()
    .describe(
      "Mensagem de erro da análise desta matrícula; nulo em caso de sucesso. Erros não interrompem o lote. Opcional.",
    )
    .nullish(),
  personalData: z.optional(
    z.lazy(() => documentOcrPersonalDataViewModelSchema),
  ),
  analysis: z.optional(z.lazy(() => documentOcrAnalysisViewModelSchema)),
}) as unknown as ToZod<DocumentOcrSnapshotResultViewModel>;
